import { IProvider } from "types/Provider/Provider";

import { api } from ".";

const providersQueries = api.injectEndpoints({
  endpoints: (builder) => ({
    getAllProviders: builder.query<{ data: IProvider[] }, void>({
      query: () => `providers`,
      providesTags: ["Provider"],
    }),
    getProvider: builder.query<{ data: IProvider }, string | undefined>({
      query: (id) => `providers/${id}`,
      providesTags: ["Provider"],
    }),
    getProvidersByAccount: builder.query<
      { data: IProvider[]; total: number },
      { accountId: string | undefined; page?: number; pageSize?: number }
    >({
      query: ({ accountId, page, pageSize }) => {
        if (page !== undefined && pageSize !== undefined) {
          return `providers/account/${accountId}?page=${page}&pageSize=${pageSize}`;
        }
        return `providers/account/${accountId}`;
      },
      providesTags: ["Provider"],
    }),
    getProvidersWithProceduresByAccount: builder.query<
      { data: IProvider[] },
      { accountId: string | undefined }
    >({
      query: ({ accountId }) =>
        `providers/account/${accountId}/with-procedures`,
      providesTags: ["Provider"],
    }),
    // CLE-2799 — every provider picker (fee schedules, contracts, payer rules, ...) reads one of
    // the queries above, so a change here must refresh them all, not just the page that made it.
    deleteProvider: builder.mutation<any, string>({
      query: (id) => ({
        url: `providers/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["Provider"],
    }),
    createProvider: builder.mutation<any, any>({
      query: (body) => ({
        url: `providers`,
        method: "POST",
        body,
      }),
      invalidatesTags: ["Provider"],
    }),
    updateProvider: builder.mutation<
      any,
      { id: string | undefined; body: any }
    >({
      query: ({ id, body }) => ({
        url: `providers/${id}`,
        method: "PUT",
        body,
      }),
      invalidatesTags: ["Provider"],
    }),
  }),
});

export const {
  useGetProvidersByAccountQuery,
  useGetProvidersWithProceduresByAccountQuery,
  useGetAllProvidersQuery,
  useGetProviderQuery,
  useDeleteProviderMutation,
  useUpdateProviderMutation,
  useCreateProviderMutation,
} = providersQueries;
